export default {
  en_gb: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.co.uk",
      language: "Language",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "es",
          url: "https://couriers.just-eat.co.uk/application",
          text: "Great Britain",
        },
      ],
    },
    hero: {
      h1Plain: "A guide to promoting",
      h1Bold: "your brand on social media",
      paragraph:
        "Marketing your business on social media is one of the most cost-effective ways to reach potential customers and stand out from the competition. This article has some hot tips and tricks for using our brand new social media pack to boost your customer engagement, plus step-step on guidelines. Let everyone know that they can order from you on [brand name]!",
      background: "",
    },
    doDont: {
      title: "Social media marketing dos and donts",
      items: [
        {
          type: "do",
          text: "Share posts during commuter hours and after work when most people are online.",
        },
        {
          type: "do",
          text: "Use short, catchy text, bright colours, and hashtags to further the reach of your content.",
        },
        {
          type: "do",
          text: "Encourage people to tag their friends, ask questions, and comment.",
        },
        {
          type: "dont",
          text: "Engage with spam accounts who might try to bait you into online arguments.",
        },
        {
          type: "dont",
          text: "Overuse hashtags. Select five to ten that accurately describe your business like #pizzeria #began #sustainability.",
        },
        {
          type: "dont",
          text: "Have a username that is different from your business name; you want potential customers to be able to find you easily and engage.",
        },
      ],
      taglineTitle:
        "Personalise your story caption to make it relevant to your specific business.",
      taglineItems: [
        {
          text: "You can write about your offers and deals, or new dishes available on your menu.",
        },
        {
          text: 'For example, ‘2 for 1 burgers every Friday’, or ‘New vegan pizzas - customise your toppings’ or ‘Don’t feel like cooking? Get meal deals here."',
        },
      ],
    },
    insta: {
      title: "How to post stories on Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Opening Instagram, go to the '+' button at the bottom centre of the app - from there you can film a new video or take a photo, or access your phone's gallery and use an existing video/photo.",
        },
        {
          img: "Language.png",
          content:
            "Add a caption, hashtag, or link to your business’ website. Just posting a video or photo without a few words of description or additional info can lead to a lack of engagement.",
        },
        {
          img: "CircleStar.png",
          content:
            "Make your Instagram stories more dynamic by adding stickers from Giphy. Just tap the sticker icon and then search for a keyword for the sticker you want, such as ‘happy’ or ‘celebration’. Pinch in/out with your fingers to resize the sticker or rotate it.",
        },
        {
          img: "Policies.png",
          content:
            'If you want to keep a copy, tap on the three dots ("More") at the bottom right and select "Save Photo/Video" to save it to your device.',
        },
      ],
      terms:
        'Please note that depending on your device, Instagram’s layout may look different. It is also not possible to post stories via the computer app. For more information specific to Instagram posting, see the official guidelines and tips <a href="#">here</a>.',
    },
    downloadable: {
      title: "Downloadable assets",
      slides: [
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/now-available-img/fr.png",
          buttonText: "Download Now",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/now-available/JE_SP1_DELIVERED_9x16_V2.1_FR.png",
        },
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/the-journey-gifs/de.gif",
          buttonText: "Download Now",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/the-journey/JE_SP1_THEJOURNEY_9x16_10s_AT.mp4",
        },
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/we-deliver-gifs/de.gif",
          buttonText: "Download Now",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/we-deliver/es_es.mp4",
        },
      ],
    },
  },

  bg_bg: {
    navbar: {
      logo: "logo_takeaway.svg",
      link: "https://www.takeaway.com/bg",
      language: "Language",
      name: "Takeaway.com",
      country_toggle: [
        {
          logo: "bg",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "Наръчник за промотиране на",
      h1Bold: "вашия бизнес в социалните мрежи",
      paragraph:
        "Представянето на вашия бизнес в социалните мрежи е един от най-рентабилните начини да достигнете потенциални клиенти и да се отличите от конкуренцията. Тази статия предлага интересни съвети и трикове за това как да използвате нашия нов пакет за социални мрежи, за да увеличите ангажираността на клиентите. Нека всички разберат, че могат да поръчат от вас на Takeaway.com!",
      background: "",
    },
    doDont: {
      title: "Какво ДА правите и какво да НЕ правите в социалните мрежи",
      items: [
        {
          type: "do",
          text: "Споделяйте постове по време на часовете, в които хората отиват и се връщат от работа – тогава повечето от тях са онлайн.",
        },
        {
          type: "do",
          text: "Използвайте кратки, забавни текстове, ярки цветове и хаштагове, за да подобрите обхвата на съдържанието си.",
        },
        {
          type: "do",
          text: "Окуражавайте хората да тагват своите приятели, да задават въпроси и да коментират.",
        },
        {
          type: "dont",
          text: "Не комуникирайте със спам профили, които могат да ви примамят в онлайн диспути.",
        },
        {
          type: "dont",
          text: "Не използвайте прекалено много хаштагове. Изберете между пет до десет, които адекватно описват вашия бизнес като #пицария #веган #устойчивост.",
        },
        {
          type: "dont",
          text: "Не използвайте потребителско име, различно от името на бизнеса си, за да помогнете на клиентите да ви намират по-лесно и да се ангажират с вас.",
        },
      ],
      taglineTitle:
        "Персонализирайте текста на вашите истории и ги направете релевантни специално за вашия бизнес.",
      taglineItems: [
        {
          text: "Можете да пишете за вашите специални оферти и отстъпки или за новите ястия в менюто ви.",
        },
        {
          text: "Например: „Всеки петък 2 бургера на цената на 1“, „Нови веган пици - с топинги по твой избор“ или „Не ти се готви? Виж нашите оферти тук“.",
        },
      ],
    },
    insta: {
      title: "Как да публикувате истории в Instagram?",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Отворете Instagram, отидете на бутона „+“ в долната централна част на приложението – от там можете да направите ново видео или снимка, или да добавите съществуващо видео или съществуваща снимка от галерията на вашия телефон.",
        },
        {
          img: "Language.png",
          content:
            "Добавете описание, хаштаг или линк към вашия бизнес уебсайт. Постването на видео или снимка без описание или допълнителна информация, може да доведе до липса на ангажираност.",
        },
        {
          img: "CircleStar.png",
          content:
            "Направете вашите Instagram истории по-динамични, като добавите стикери от Giphy. Можете да направите това, като кликнете на иконата със стикер и след това потърсите стикера, който желаете по ключова дума, като например „щастие“, „вкусно“ или „вечеря“. След това ще видите разнообразие от стикери, от които да изберете. Допирайте и отдалечавайте палеца и показалеца си по екрана, за да промените размера на стикера или да го завъртите.",
        },
        {
          img: "Policies.png",
          content:
            "Ако искате да запазите копие, кликнете на трите точки („Още“) в горната дясна част на екрана и изберете „Запазване на снимка/видео“, за да ги запазите в устройството си.",
        },
      ],
      terms:
        'Моля, обърнете внимание, че в зависимост от вашето устройство, Instagram може да изглежда по различен начин. Също така е възможно да публикувате истории чрез приложението за компютър. За повече информация относно специфични публикации в Instagram, вижте официалните насоки и съвети <a href="https://help.instagram.com/1660923094227526/?locale=bg_BG&helpref=hc_fnav&cms_id=1660923094227526&force_new_ighc=false" target="_blank">тук</a>.',
    },
    downloadable: {
      title: "Материали за изтегляне",
      slides: [
        {
          image: require("@/assets/country-downloadable/BG/bg-1.png"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/BG/bg-2.png"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/BG/bg-3.png"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/BG/bg-bg-1.mp4"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-bg-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BG/bg-bg-2.mp4"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-bg-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BG/bg-bg-3.mp4"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-bg-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BG/bg-bg-4.mp4"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-bg-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BG/bg-bg-5.mp4"),
          buttonText: "Изтеглете сега",
          buttonURL: require("@/assets/country-downloadable/BG/bg-bg-5.mp4"),
        },
      ],
    },
  },

  be_fr: {
    navbar: {
      logo: "logo_takeaway.svg",
      link: "https://takeaway.com/be-fr",
      language: "Langue",
      name: "Takeaway.com",
      country_toggle: [
        {
          logo: "fr",
          url: "https://www.takeaway.com/be-fr/information/partenaire-kit-reseaux-sociaux",
          text: "Français",
        },
        {
          logo: "nl",
          url: "https://www.takeaway.com/be/informatie/partner-social-media-kit",
          text: "Nederlands",
        },
      ],
    },
    hero: {
      h1Plain: "Guide pour apprendre à promouvoir",
      h1Bold: "votre marque sur les réseaux sociaux",
      paragraph:
        "Promouvoir votre entreprise sur les réseaux sociaux et l’une des manières les plus efficaces d’atteindre vos prospects et de vous démarquer de la compétition. Cet article contient des astuces et vous indique la marche à suivre pour augmenter l’engagement des client·e·s à l’aide de notre tout nouveau pack réseaux sociaux. Pour que tout le monde sache que vous êtes disponible sur Takeaway.com !",
    },
    doDont: {
      title:
        "Bonnes et mauvaises pratiques de marketing sur les réseaux sociaux",
      items: [
        {
          type: "do",
          text: "Publier du contenu pendant les heures de pointe et après les journées de travail, quand les client·e·s sont en ligne.",
        },
        {
          type: "do",
          text: "Utiliser des phrases courtes et accrocheuses, des couleurs vives et des hashtags pour toucher plus de personnes avec votre contenu.",
        },
        {
          type: "do",
          text: "Encourager vos abonné·e·s à taguer leurs ami·e·s, à poser des questions et à commenter vos publications.",
        },
        {
          type: "dont",
          text: "Interagir avec des comptes spam qui tentent de vous entraîner dans des disputes en ligne.",
        },
        {
          type: "dont",
          text: "tiliser les hashtags à outrance. Choisissez-en cinq à dix qui décrivent précisément votre activité, comme #pizzeria #vegan #durabilité.",
        },
        {
          type: "dont",
          text: "Avoir un nom d’utilisateur différent du nom de votre entreprise ; vos client·e·s doivent pouvoir vous trouver facilement pour créer de l’engagement.",
        },
      ],
      taglineTitle:
        "Personnalisez le texte de votre story pour qu’il corresponde à votre entreprise.",
      taglineItems: [
        {
          text: "Vous pouvez parler de vos offres et promotions ou des nouveaux plats disponibles sur votre carte.",
        },
        {
          text: "Par exemple : « 2 burgers pour le prix d’un tous les vendredis » ou « Nouvelles pizzas vegan : choisissez votre garniture » ou « La flemme de cuisiner ? Profitez de nos offres juste ici. »",
        },
      ],
    },
    insta: {
      title: "Comment publier des stories sur Instagram ?",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Ouvrez Instagram, appuyez sur le bouton « + », en bas au centre, puis sélectionnez «∘Story∘» dans le menu coulissant en bas de l’écran. Vous pouvez ensuite filmer une vidéo, prendre une photo ou accéder à la galerie de votre téléphone pour utiliser une photo/vidéo existante.",
        },
        {
          img: "Language.png",
          content:
            "Ajoutez du texte, un hashtag ou un lien vers le site web de votre entreprise. Poster une vidéo ou une photo sans texte ni informations supplémentaires peut entraîner un manque d’engagement.",
        },
        {
          img: "CircleStar.png",
          content:
            "Proposez des stories Instagram plus dynamiques en ajoutant des stickers avec Giphy. Il vous suffit de cliquer sur l’icône sticker et de chercher un mot clé comme « bonheur », « fête » ou « chat drôle ». Vous pourrez ensuite faire votre choix parmi toute une sélection de stickers différents. Ajustez la taille du sticker en écartant/approchant deux doigts et tournez-les pour le faire pivoter.",
        },
        {
          img: "Policies.png",
          content:
            "Si vous voulez conserver une copie de votre story, cliquez sur les trois points en haut à droite et sélectionnez « Enregistrer » pour l’enregistrer sur votre appareil.",
        },
      ],
      terms:
        'À noter que l’apparence d’Instagram peut différer selon votre appareil. De plus, il est impossible de poster des stories depuis un ordinateur. Pour en savoir plus sur la publication de contenu avec Instagram, consultez les directives et astuces officielles <a href="https://help.instagram.com/1660923094227526/?locale=fr_FR&helpref=hc_fnav&cms_id=1660923094227526&force_new_ighc=false" target="_blank">ici</a>.',
    },
    downloadable: {
      title: "Ressources téléchargeables",
      slides: [
        {
          image: require("@/assets/country-downloadable/BE-fr/be-fr-1.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-fr-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/BE-fr/be-fr-2.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-fr-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/BE-fr/be-fr-3.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-fr-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/BE-fr/be-FR-1.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-FR-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-fr/be-FR-2.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-FR-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-fr/be-FR-3.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-FR-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-fr/be-FR-4.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-FR-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-fr/be-FR-5.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/BE-fr/be-FR-5.mp4"),
        },
      ],
    },
  },

  be_nl: {
    navbar: {
      logo: "logo_takeaway.svg",
      link: "https://www.takeaway.com/be",
      language: "Taal",
      name: "Takeaway.com",
      country_toggle: [
        {
          logo: "nl",
          url: "https://www.takeaway.com/be/informatie/partner-social-media-kit",
          text: "Nederlands",
        },
        {
          logo: "fr",
          url: "https://www.takeaway.com/be-fr/information/partenaire-kit-reseaux-sociaux",
          text: "Français",
        },
      ],
    },
    hero: {
      h1Plain: "Een handleiding voor het promoten",
      h1Bold: "van uw merk op sociale media",
      paragraph:
        "Het marketen van uw bedrijf via sociale media is een van de meest kosteneffectieve manieren om potentiële klanten te bereiken en u te onderscheiden van de concurrentie. Dit artikel bevat een aantal tips en trucs voor het gebruik van ons gloednieuwe social media pakket om het contact met uw klanten te stimuleren, inclusief stap-voor-stap instructies. Laat iedereen weten dat ze bij u via Takeaway.com kunnen bestellen.",
    },
    doDont: {
      title: "Social media marketing do's en donts",
      items: [
        {
          type: "do",
          text: "Deel berichten tijdens de pendeltijden en na kantooruren, want dan zijn de meeste mensen online.",
        },
        {
          type: "do",
          text: "Gebruik korte, pakkende tekst, felle kleuren en hashtags om het bereik van uw inhoud te vergroten.",
        },
        {
          type: "do",
          text: "Moedig mensen aan om hun vrienden te taggen, vragen te stellen en commentaar te geven.",
        },
        {
          type: "dont",
          text: "Ga in gesprek met spam-accounts die u proberen te dwingen om online in discussie te gaan.",
        },
        {
          type: "dont",
          text: "Overmatig gebruik van hashtags. Kies er vijf tot tien die uw bedrijf nauwkeurig beschrijven, zoals #pizzeria #vegan #duurzaamheid.",
        },
        {
          type: "dont",
          text: "Gebruik een gebruikersnaam die verschilt van uw bedrijfsnaam; u wilt dat potentiële klanten u gemakkelijk kunnen vinden en met u in contact kunnen komen.",
        },
      ],
      taglineTitle:
        "Personaliseer uw bijschrift om uw verhaal relevant te maken voor uw specifieke bedrijf.",
      taglineItems: [
        {
          text: "U kunt schrijven over uw aanbiedingen en deals, of over nieuwe gerechten op uw menu.",
        },
        {
          text: "Bijvoorbeeld 'elke vrijdag 2 voor 1 burgers', of 'nieuwe vegan pizza's - pas uw toppings aan' of 'geen zin om te koken? Koop hier maaltijddeals.'",
        },
      ],
    },
    insta: {
      title: "Hoe verhalen op Instagram posten",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Als u Instagram opent, gaat u naar de knop " +
            " in het midden onderaan de app - van daaruit kunt u een nieuwe video filmen of een foto maken, of u kunt naar de galerij van uw telefoon gaan en een bestaande video/foto gebruiken.",
        },
        {
          img: "Language.png",
          content:
            "Voeg een bijschrift, hashtag of link naar de website van uw bedrijf toe. Het zomaar posten van een video of foto zonder een korte beschrijving of extra informatie kan leiden tot een gebrek aan betrokkenheid.",
        },
        {
          img: "CircleStar.png",
          content:
            "Maak uw Instagram-verhalen dynamischer met stickers van Giphy. U kunt dit doen door op het stickerpictogram te tikken en vervolgens een trefwoord te zoeken voor de sticker die u wilt, zoals 'blij' of 'feest' of 'grappige kat'. U krijgt dan verschillende stickers te zien waaruit u kunt kiezen. Pinch in/out met uw vingers om het formaat van de sticker aan te passen of de sticker te draaien.",
        },
        {
          img: "Policies.png",
          content:
            'Als u een kopie wilt bewaren, tikt u op de drie puntjes ("Meer") rechtsonder en selecteert u "Foto/Video opslaan" om het op uw apparaat op te slaan.',
        },
      ],
      terms:
        'Houd er rekening mee dat, afhankelijk van uw apparaat, de lay-out van Instagram er anders uit kan zien. Het is ook niet mogelijk om verhalen te plaatsen via de computer-app. Voor meer specifieke informatie over het posten op Instagram, bekijk de officiële richtlijnen en tips <a href="https://help.instagram.com/1660923094227526/?locale=nl_NL&helpref=hc_fnav&cms_id=1660923094227526&force_new_ighc=false" target="_blank">hier</a>.',
    },
    downloadable: {
      title: "Downloadbare activa",
      slides: [
        {
          image: require("@/assets/country-downloadable/BE-nl/be-nl-1.png"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-nl-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/BE-nl/be-nl-2.png"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-nl-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/BE-nl/be-nl-3.png"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-nl-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/BE-nl/be-NL-1.mp4"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-NL-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-nl/be-NL-2.mp4"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-NL-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-nl/be-NL-3.mp4"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-NL-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-nl/be-NL-4.mp4"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-NL-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/BE-nl/be-Nl-5.mp4"),
          buttonText: "Nu downloaden",
          buttonURL: require("@/assets/country-downloadable/BE-nl/be-Nl-5.mp4"),
        },
      ],
    },
  },

  dk_dk: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.dk",
      language: "Language",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "dk",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "Din guide til at promovere",
      h1Bold: "dit brand på sociale medier",
      paragraph:
        "Markedsføring af din virksomhed på sociale medier er en af ​​de mest effektive måder at nå ud til potentielle kunder og skille dig ud fra konkurrenterne.<br><br>I denne artikel giver vi dig gode tips og tricks til at få kundermes opmærksomhed ved at bruge vores splinternye pakker til sociale medier.<br><br>Lad alle vide, at de kan bestille hos dig på Just Eat!",
    },
    doDont: {
      title: "Do's and don'ts på sociale medier",
      items: [
        {
          type: "do",
          text: "Del dit opslag i det tidsrum, hvor folk pendler til og fra arbejde. Så er de fleste online.",
        },
        {
          type: "do",
          text: "Du kan opfordre folk til at tagge deres venner, stille spørgsmål og kommentere på dit opslag for at bygge en relation til dine følgere.",
        },
        {
          type: "do",
          text: "Opfordre folk til at tagge deres venner, stille spørgsmål og kommentere.",
        },
        {
          type: "dont",
          text: "Hold dig fra at engagere med spamkonti, der kan forsøge at lokke dig til online-skænderier.",
        },
        {
          type: "dont",
          text: "Lad være med at bruge for mange hashtags. Vælg i stedet 5 til 10 hashtags der præcist beskriver din virksomhed, fx #pizzeria #vegan #sustainability.",
        },
        {
          type: "dont",
          text: "Sørg for, at have et brugernavn, der matcher dit virksomhedsnavn. Du ønsker, at potentielle kunder nemt kan finde dig.",
        },
      ],
      taglineTitle:
        "Husk dine stories: Gør dem relevante med en personlig tekst",
      taglineItems: [
        {
          text: "Du kan eksempelvis fortælle om dine tilbud og deals eller beskrive de nyeste retter på din menu.",
        },
        {
          text: "Du kan for eksempel skrive: “Få to burgere for én burgers pris, hver fredag”, “Nye veganske pizzaer! Vælg selv dine toppings” eller “Har du ikke tid til madlavningen? Se de bedste deals på dine livretter”.",
        },
      ],
    },
    insta: {
      title: "Sådan deler du stories på Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Åbn Instagram, gå til “+”-knappen nederst i midten af ​​appen. Derfra kan du filme en ny video, tage et billede eller få adgang til din telefons galleri og finde en video/et billede.",
        },
        {
          img: "Language.png",
          content:
            "Tilføj en billedtekst, et hashtag eller et link til din virksomheds hjemmeside. Hvis du deler en video eller et billede uden kommentarer eller yderligere info, kan det have en negativ effekt.",
        },
        {
          img: "CircleStar.png",
          content:
            "Gør dine Instagram-stories mere dynamiske ved at tilføje klistermærker fra Giphy. Du kan gøre dette ved at trykke på mærkatikonet og derefter søge på et nøgleord for det mærkat, du ønsker, såsom “glad” eller “fest” eller “sjov kat”. Du vil derefter se en række forskellige klistermærker, du kan vælge imellem. Zoom ind/ud med fingrene for at ændre størrelsen på klistermærket eller rotere det.",
        },
        {
          img: "Policies.png",
          content:
            "Hvis du vil beholde en kopi, skal du trykke på de tre prikker (“Mere”) nederst til højre og vælge “Gem foto/video” for at gemme den på din enhed.",
        },
      ],
      terms:
        'Bemærk venligst, at, afhængigt af din enhed, kan Instagrams layout se anderledes ud. Det er heller ikke muligt at poste stories via din computer. Se de officielle retningslinjer og tips for mere information om Instagram-opslag <a href="https://help.instagram.com/1660923094227526/?locale=da_DK&helpref=hc_fnav&cms_id=1660923094227526&force_new_ighc=false" target="_blank">her</a>.',
    },
    downloadable: {
      title: "Filer, der kan downloades",
      slides: [
        {
          image: require("@/assets/country-downloadable/DK/dk-1.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/DK/dk-2.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/DK/dk-3.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/DK/dk-dk-1.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-dk-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DK/dk-dk-2.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-dk-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DK/dk-dk-3.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-dk-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DK/dk-dk-4.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-dk-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DK/dk-dk-5.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/DK/dk-dk-5.mp4"),
        },
      ],
    },
  },

  nl_nl: {
    navbar: {
      logo: "logo_thuisbezorgd.svg",
      link: "https://www.thuisbezorgd.nl",
      language: "Language",
      name: "Thuisbezorgd",
      country_toggle: [
        {
          logo: "nl",
          url: "https://couriers.just-eat.co.uk/application",
          text: "Great Britain",
        },
      ],
    },
    hero: {
      h1Plain: "Een gids om jouw merk",
      h1Bold: "op social media te promoten",
      paragraph:
        "Social media gebruiken voor je marketing is een van de meest kostenefficiënte manieren om potentiële klanten te bereiken en je te onderscheiden van de concurrentie. In dit artikel krijg je tips en richtlijnen voor het gebruik van ons social media pakket om de interactie met klanten te stimuleren. Laat iedereen weten dat ze bij jou kunnen bestellen via Thuisbezorgd.nl!",
    },
    doDont: {
      title: "Marketing op social media: do’s en dont’s",
      items: [
        {
          type: "do",
          text: "Deel berichten in de piekuren en na het werk, wanneer de meeste mensen online zijn.",
        },
        {
          type: "do",
          text: "Gebruik korte en pakkende teksten, felle kleuren en hashtags om het bereik van je bericht te vergroten.",
        },
        {
          type: "do",
          text: "Moedig mensen aan om hun vrienden te taggen, vragen te stellen en reacties achter te laten.",
        },
        {
          type: "dont",
          text: "In gesprek gaan met spamaccounts die je proberen te verleiden tot online discussies.",
        },
        {
          type: "dont",
          text: "Te veel hashtags gebruiken. Kies er vijf tot tien die je bedrijf goed beschrijven, zoals #pizzeria #vegan #duurzaamheid.",
        },
        {
          type: "dont",
          text: "Een gebruikersnaam gebruiken die anders is dan je bedrijfsnaam; je wilt dat (potentiële) klanten je gemakkelijk kunnen vinden en met je in contact kunnen komen.",
        },
      ],
      taglineTitle:
        "Personaliseer het bijschrift in je verhaal en stem het volledig af op jouw bedrijf.",
      taglineItems: [
        {
          text: "Je kunt iets schrijven over je aanbiedingen en deals, of over nieuwe gerechten op je menu.",
        },
        {
          text: "Bijvoorbeeld: ‘Elke vrijdag 2 burgers voor de prijs van 1’ of ‘Nieuwe vegan pizza’s - kies je eigen toppings’ of ‘Geen zin om te koken? Wij hebben maaltijddeals voor je’.",
        },
      ],
    },
    insta: {
      title: "Zo post je stories op Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Als je Instagram opent, ga je naar de ‘+’-knop in het midden onderaan de app. Daar kun je een nieuwe video filmen of een foto maken, of je kunt een bestaande video/foto uit de galerij van je telefoon gebruiken.",
        },
        {
          img: "Language.png",
          content:
            "Voeg een bijschrift, hashtag of link naar de website van je bedrijf toe. Alleen een video of foto plaatsen zonder een korte beschrijving of extra informatie kan leiden tot een gebrek aan betrokkenheid.",
        },
        {
          img: "CircleStar.png",
          content:
            "Maak je verhalen op Instagram levendiger door stickers van Giphy toe te voegen. Dit doe je door op het stickericoontje te tikken en vervolgens een trefwoord te zoeken voor de sticker die je wilt, zoals ‘blij’ of ‘feest’ of ‘grappige kat’. Je krijgt dan verschillende stickers te zien waaruit je kunt kiezen. Met je vingers kun je de sticker verkleinen of draaien.",
        },
        {
          img: "Policies.png",
          content:
            "Als je een kopie wilt bewaren, tik dan op de drie puntjes (‘Meer’) rechtsonder en selecteer ‘Foto/Verhaal opslaan’ om het bericht op je apparaat op te slaan.",
        },
      ],
      terms:
        'Let op: afhankelijk van je apparaat kan de lay-out van Instagram er anders uitzien. Het is ook niet mogelijk om verhalen te plaatsen via de computer-app. Voor meer informatie over het plaatsen van Instagramposts, bekijk je <a href="https://help.instagram.com/1660923094227526/?locale=nl_NL&helpref=hc_fnav&cms_id=1660923094227526&force_new_ighc=false" target="_blank">hier</a> de officiële richtlijnen en tips.',
    },
    downloadable: {
      title: "Materialen om te downloaden",
      slides: [
        {
          image: require("@/assets/country-downloadable/NL/nl-1.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/NL/nl-2.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/NL/nl-3.png"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/NL/nl-nl-1.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-nl-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/NL/nl-nl-2.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-nl-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/NL/nl-nl-3.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-nl-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/NL/nl-nl-4.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-nl-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/NL/nl-nl-5.mp4"),
          buttonText: "Download nu",
          buttonURL: require("@/assets/country-downloadable/NL/nl-nl-5.mp4"),
        },
      ],
    },
  },

  ch_fr: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.ch/fr",
      language: "Langue",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "fr",
          url: "https://www.just-eat.ch/fr/informations/partenaire-kit-reseaux-sociaux",
          text: "Français",
        },
        {
          logo: "de",
          url: "https://www.just-eat.ch/informationen/partner-social-media-kit",
          text: "Deutsch",
        },
      ],
    },
    hero: {
      h1Plain: "Un guide pour promouvoir votre",
      h1Bold: "marque sur les réseaux sociaux",
      paragraph:
        "Mettre en avant votre établissement sur les réseaux sociaux est l’un des moyens les plus efficaces d’atteindre des client·e·s potentiel·le·s et de vous démarquer de la concurrence. Cet article propose des astuces et directives détaillées pour renforcer la fidélité de vos client·e·s à l’aide de notre pack réseaux sociaux. Faites savoir à tout le monde qu'ils·elles peuvent commander chez vous sur Just Eat !",
    },
    doDont: {
      title: "Bonnes et mauvaises pratiques marketing sur les réseaux sociaux",
      items: [
        {
          type: "do",
          text: "Partager des publications pendant les heures de pointe et après les journées de travail, quand les gens sont en ligne.",
        },
        {
          type: "do",
          text: "Utiliser des formulations courtes accrocheuses, des couleurs vives et des hashtags pour toucher plus de personnes avec votre contenu.",
        },
        {
          type: "do",
          text: "Encourager les personnes qui vous suivent à partager votre contenu avec leurs ami·e·s, à poser des questions et à commenter.",
        },
        {
          type: "dont",
          text: "Interagir avec des comptes spam qui tenteraient de vous entraîner dans des disputes en ligne.",
        },
        {
          type: "dont",
          text: "Utiliser les hashtags à outrance. Choisissez-en cinq à dix qui collent précisément avec votre activité, comme #pizzeria #vegane #durabilité.",
        },
        {
          type: "dont",
          text: "Avoir un nom d’utilisateur·trice différent du nom de votre entreprise ; vos client·e·s doivent pouvoir vous trouver facilement pour créer de l’engagement.",
        },
      ],
      taglineTitle:
        "Personnalisez votre description pour qu’elle soit pertinente pour votre établissement.",
      taglineItems: [
        {
          text: "Vous pouvez communiquer sur vos offres et bons plans ou encore sur les nouveautés de votre menu.",
        },
        {
          text: "Par exemple : « 2 burgers pour le prix d’un tous les vendredis », ou « Nouvelles pizzas véganes: personnalisez vos toppings » ou « Vous n’avez pas envie de cuisiner ? Profitez de nos offres juste ici ».",
        },
      ],
    },
    insta: {
      title: "Comment publier des stories sur Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Ouvrez Instagram, appuyez sur le bouton « + » en bas au centre de l’application. Faites une vidéo, prenez une photo ou accédez à la galerie de votre téléphone pour utiliser une photo/vidéo existante.",
        },
        {
          img: "Language.png",
          content:
            "Ajoutez du texte, un hashtag, ou un lien vers le site web de votre établissement. Poster une vidéo ou une photo sans texte ni information supplémentaire peut entraîner un manque d’engagement.",
        },
        {
          img: "CircleStar.png",
          content:
            "Proposez des stories Instagram plus dynamiques en ajoutant des stickers avec Giphy. Il vous suffit de cliquer sur l’icône sticker et de chercher un mot clé comme « bonheur », « fête » ou « chat marrant ». Vous pourrez ensuite faire votre choix parmi toute une sélection de stickers différents. Pincez ou écartez vos doigts pour ajuster la taille du sticker et tournez-le pour le faire pivoter.",
        },
        {
          img: "Policies.png",
          content:
            "Si vous voulez conserver une copie de votre story, cliquez sur les trois points (« Plus ») en bas à droite et sélectionnez « Enregistrer la photo/vidéo » pour l’enregistrer sur votre appareil.",
        },
      ],
      terms:
        'À noter que l’apparence d’Instagram peut changer en fonction de votre appareil. De plus, il est impossible de poster des stories depuis un ordinateur. Pour en savoir plus sur la publication de contenu avec Instagram, consultez les directives et astuces officielles <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">ici</a>.',
    },
    downloadable: {
      title: "Ressources à télécharger",
      slides: [
        {
          image: require("@/assets/country-downloadable/CH-fr/ch-fr-1.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/CH-fr/ch-fr-2.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/CH-fr/ch-fr-3.png"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/CH-fr/ch-fr-1.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-fr/ch-fr-2.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-fr/ch-fr-3.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-fr/ch-fr-4.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-fr/ch-fr-5.mp4"),
          buttonText: "Télécharger maintenant",
          buttonURL: require("@/assets/country-downloadable/CH-fr/ch-fr-5.mp4"),
        },
      ],
    },
  },

  ch_de: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.ch/",
      language: "Sprache",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "de",
          url: "https://www.just-eat.ch/informationen/partner-social-media-kit",
          text: "Deutsch",
        },
        {
          logo: "fr",
          url: "https://www.just-eat.ch/fr/informations/partenaire-kit-reseaux-sociaux",
          text: "Français",
        },
      ],
    },
    hero: {
      h1Plain: "So bewirbst du deine",
      h1Bold: "Marke auf Social Media",
      paragraph:
        "Das Vermarkten deines Unternehmens in sozialen Medien ist eine der kostengünstigsten Möglichkeiten, potenzielle Kund:innen zu erreichen und sich von der Konkurrenz abzuheben. In diesem Artikel findest du einige Tipps und Tricks zur Nutzung unseres brandneuen Social-Media-Pakets, um das Kundenengagement zu steigern, sowie Schritt-für-Schritt-Anleitungen. Lass alle wissen, dass sie bei Just Eat bestellen können!",
    },
    doDont: {
      title: "Dos und Don’ts für Social-Media-Marketing",
      items: [
        {
          type: "do",
          text: "Teile Posts morgens während der Rush Hour und nach Feierabend, denn dann sind die meisten Leute online.",
        },
        {
          type: "do",
          text: "Nutze kurze, prägnante Texte, leuchtende Farben und Hashtags, um mit deinen Inhalten mehr Leute zu erreichen.",
        },
        {
          type: "do",
          text: "Fordere dazu auf, dass die Leute ihre Freund:innen markieren, Fragen stellen oder Kommentare posten.",
        },
        {
          type: "dont",
          text: "Interagiere nicht mit Spam-Accounts, die versuchen könnten, dich zu Online-Diskussionen zu provozieren.",
        },
        {
          type: "dont",
          text: "Nutze nicht zu viele Hashtags. Wähle fünf bis zehn, die genau zu deinem Geschäft passen. Beispiele: #Pizzeria #Vegan #Nachhaltigkeit.",
        },
        {
          type: "dont",
          text: "Verwende keinen Benutzernamen, der sich von deinem Geschäftsnamen unterscheidet. Denn potenzielle Kund:innen sollen dich leicht finden und erkennen können.",
        },
      ],
      taglineTitle:
        "Personalisiere die Texte zu deiner Story, damit sie zu deinem Geschäft passen.",
      taglineItems: [
        {
          text: "Du kannst Angebote oder neue Gerichte bewerben.",
        },
        {
          text: "Ein paar Beispiele: „Freitag ist Burger-Tag: 2 zum Preis von 1“ oder „Neu: Vegane Pizza mit deinem Wunschbelag“ oder „Keine Lust auf Kochen? Nutze unser Mittagsangebot!“",
        },
      ],
    },
    insta: {
      title: "So postest du Storys auf Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Öffne Instagram und tippe auf den „+“-Button unten mittig in der App. Nun kannst du ein neues Video aufnehmen, ein Foto machen oder deine Galerie aufrufen und ein bereits vorhandenes Video bzw. Foto auswählen.",
        },
        {
          img: "Language.png",
          content:
            "Fügen eine Beschreibung, Hashtags oder den Link zu deiner Webseite hinzu. Wenn du ein Video oder Foto ohne passende Beschreibung oder Informationen postest, reagieren Follower und Besucher wahrscheinlich weniger darauf.",
        },
        {
          img: "CircleStar.png",
          content:
            "Besonders dynamisch wirken Instagram-Storys mit Stickers von Giphy. Tippe hierfür auf das Sticker-Symbol und suche dann per Stichwort nach dem passenden Sticker. Stichworte könnten etwa „Happy“ oder „Rabatt“ sein. Dann werden dir verschiedene Sticker zur Auswahl angezeigt. Mit deinen Fingern kannst du nun den Sticker in der Grösse anpassen oder rotieren.",
        },
        {
          img: "Policies.png",
          content:
            "Wenn du eine Kopie speichern möchtest, tippe auf die drei Punkte („Mehr“) unten rechts und wähle „Foto/Video speichern“, um sie auf deinem Gerät zu speichern.",
        },
      ],
      terms:
        'Bitte beachte: Abhängig von deinem Gerät sieht das Layout von Instagram vielleicht etwas anders aus. Es ist auch nicht möglich, Storys über die Computer-App zu posten. Weitere Informationen, speziell zum Posten auf Instagram, findest du <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">hier</a> in den offiziellen Richtlinien und Tipps.',
    },
    downloadable: {
      title: "Jetzt Vorlagen herunterladen",
      slides: [
        {
          image: require("@/assets/country-downloadable/CH-de/ch-de-1.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/CH-de/ch-de-2.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/CH-de/ch-de-3.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/CH-de/ch-de-1.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-de/ch-de-2.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-de/ch-de-3.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-de/ch-de-4.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/CH-de/ch-de-5.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/CH-de/ch-de-5.mp4"),
        },
      ],
    },
  },

  fr_fr: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.fr",
      language: "Langue",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "fr",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "Un guide pour promouvoir votre",
      h1Bold: "marque sur les réseaux sociaux",
      paragraph:
        "Mettre en avant votre établissement sur les réseaux sociaux est l’un des moyens les plus efficaces d’atteindre des clients potentiels et de vous démarquer de la concurrence. Cet article propose des astuces et directives détaillées pour renforcer la fidélité de vos client·e·s à l’aide de notre pack réseaux sociaux. Faites savoir à tout le monde qu'ils peuvent commander chez vous sur Just Eat !",
    },
    doDont: {
      title: "Bonnes et mauvaises pratiques marketing sur les réseaux sociaux",
      items: [
        {
          type: "do",
          text: "Partager des publications pendant les heures de pointe et après les journées de travail, quand les gens sont en ligne.",
        },
        {
          type: "do",
          text: "Utiliser des formulations courtes accrocheuses, des couleurs vives et des hashtags pour toucher plus de personnes avec votre contenu.",
        },
        {
          type: "do",
          text: "Encouragez les personnes qui vous suivent à partager votre contenu avec leurs amis, à poser des questions et à commenter.",
        },
        {
          type: "dont",
          text: "Interagir avec des comptes spam qui tenteraient de vous entraîner dans des disputes en ligne.",
        },
        {
          type: "dont",
          text: "Utiliser les hashtags à outrance. Choisissez-en cinq à dix qui collent précisément avec votre activité, comme #pizzeria #vegan #durabilité.",
        },
        {
          type: "dont",
          text: "Avoir un nom d’utilisateur différent du nom de votre entreprise ; vos clients doivent pouvoir vous trouver facilement pour créer de l’engagement.",
        },
      ],
      taglineTitle:
        "Personnalisez votre description pour qu’elle soit pertinente pour votre établissement.",
      taglineItems: [
        {
          text: "Vous pouvez communiquez sur vos offres et bons plans ou encore sur les nouveautés de votre menu.",
        },
        {
          text: "Par exemple : « 2 burgers pour le prix d’un tous les vendredis », ou « Nouvelles pizzas vegan : personnalisez vos toppings » ou « Vous n’avez pas envie de cuisiner ? Profitez de nos offres juste ici ».",
        },
      ],
    },
    insta: {
      title: "Comment publier des stories sur Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Ouvrez Instagram, appuyez sur le bouton « + » en bas au centre de l’application. Filmez une vidéo, prenez une photo ou accédez à la galerie de votre téléphone pour utiliser une photo/vidéo existante.",
        },
        {
          img: "Language.png",
          content:
            "Ajoutez du texte, un hashtag, ou un lien vers le site web de votre établissement. Poster une vidéo ou une photo sans texte ni information supplémentaire peut entraîner un manque d’engagement.",
        },
        {
          img: "CircleStar.png",
          content:
            "Proposez des stories Instagram plus dynamiques en ajoutant des stickers avec Giphy. Il vous suffit de cliquer sur l’icône sticker et de chercher un mot clé comme « bonheur », « fête » ou « chat marrant ». Vous pourrez ensuite faire votre choix parmi toute une sélection de stickers différents. Pincez ou écartez vos doigts pour ajuster la taille du sticker et tournez-le pour le faire pivoter.",
        },
        {
          img: "Policies.png",
          content:
            "Si vous voulez conserver une copie de votre story, cliquez sur les trois points (« Plus ») en bas à droite et sélectionnez « Enregistrer la photo/vidéo » pour l’enregistrer sur votre appareil.",
        },
      ],
      terms:
        'À noter que l’apparence d’Instagram peut changer en fonction de votre appareil. De plus, il est impossible de poster des stories depuis un ordinateur. Pour en savoir plus sur la publication de contenu avec Instagram, consultez les directives et astuces officielles <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">ici</a>.',
    },
    downloadable: {
      title: "Contenu téléchargeable",
      slides: [
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/now-available-img/fr_fr.png",
          buttonText: "Télécharger maintenant",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/now-available/fr_fr.zip",
        },
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/the-journey-gifs/fr_fr.gif",
          buttonText: "Télécharger maintenant",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/the-journey/fr_fr.zip",
        },
        {
          image:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/we-deliver-gifs/fr_fr.gif",
          buttonText: "Télécharger maintenant",
          buttonURL:
            "https://takeaway-landing-pages.k.elnino-production.com/storage/resources/social-media-perks/downloadable/we-deliver/fr_fr.zip",
        },
      ],
    },
  },

  at_de: {
    navbar: {
      logo: "logo_lieferando.svg",
      link: "https://www.lieferando.at/",
      language: "Sprache",
      name: "Lieferando",
      country_toggle: [
        {
          logo: "at",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "So bewerben Sie Ihr",
      h1Bold: "Geschäft auf Social Media",
      paragraph:
        "Ihr Geschäft auf Social Media zu bewerben ist eine kosteneffiziente Möglichkeit, potenzielle Kund:innen zu erreichen und sich von der Konkurrenz abzuheben. In diesem Artikel erhalten Sie Tipps und Tricks, wie Sie unser brandneues Social-Media-Paket nutzen können, um die Kundenbindung zu steigern. Alles wird Schritt für Schritt erklärt. Zeigen Sie allen, dass Sie bei Ihnen über Lieferando bestellen können!",
    },
    doDont: {
      title: "Marketing in den sozialen Medien - was man beachten sollte",
      items: [
        {
          type: "do",
          text: "Teilen Sie Posts am Morgen, während der Stoßzeiten und nach Feierabend, da die meisten Kund:innen dann online sind.",
        },
        {
          type: "do",
          text: "Nutzen Sie kurze, prägnante Texte, leuchtende Farben und Hashtags, um mit Ihren Inhalten mehr Kund:innen zu erreichen.",
        },
        {
          type: "do",
          text: "Fordern Sie potenzielle Kund:innen auf, ihre Freund:innen zu markieren, Fragen stellen oder Kommentare posten.",
        },
        {
          type: "dont",
          text: "Kommunizieren Sie nicht mit Spam-Konten, die Sie möglicherweise nur in einen Online-Streit verwickeln wollen.",
        },
        {
          type: "dont",
          text: "Nutzen Sie nicht zu viele Hashtags. Wählen Sie fünf bis zehn, die genau zu Ihrem Geschäft passen. Zum Beispiel: #Pizzeria #Vegan #Nachhaltigkeit.",
        },
        {
          type: "dont",
          text: "Verwenden Sie keinen Benutzernamen, der sich von Ihrem Geschäftsnamen unterscheidet, damit potenzielle Kund:innen Sie leicht finden und erkennen können.",
        },
      ],
      taglineTitle:
        "Stellen Sie sicher, dass die Texte in Ihrer Story zu Ihrem Geschäft passen",
      taglineItems: [
        {
          text: "Sie können Angebote, Aktionen oder neue Gerichte bewerben.",
        },
        {
          text: "Hier ein paar Beispiele: „Freitag ist Burger-Tag: 2 zum Preis von 1“ oder „Neu: Vegane Pizza mit deinem Wunschbelag“ oder „Keine Lust auf Kochen? Nutze unser Mittagsangebot!“",
        },
      ],
    },
    insta: {
      title: "So posten Sie Storys auf Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Öffnen Sie Instagram und tippen Sie auf die „+“-Schaltfläche unten in der Mitte der App. Sie können nun ein Video drehen, ein Foto machen oder ein bereits vorhandenes Video bzw. Foto aus Ihrer Galerie auswählen.",
        },
        {
          img: "Language.png",
          content:
            "Fügen Sie eine Beschreibung, Hashtags oder einen Link zu Ihrer Webseite hinzu. Posts ohne passende Beschreibung oder Informationen erhalten wahrscheinlich weniger Reaktionen von Followern und Besuchern.",
        },
        {
          img: "CircleStar.png",
          content:
            "Instagram-Storys wirken besonders dynamisch mit Stickern von Giphy. Tippen Sie auf das Sticker-Symbol und suchen Sie nach einem passenden Sticker mit Stichwörtern wie „Happy“, „Feier“ oder „lustige Katze“. Sie können die Größe und Ausrichtung der Sticker mit Ihren Fingern anpassen.",
        },
        {
          img: "Policies.png",
          content:
            "Um eine Kopie zu speichern, tippen Sie auf die drei Punkte („Mehr“) unten rechts und wählen Sie „Foto/Video speichern“, um es auf Ihrem Gerät zu speichern.",
        },
      ],
      terms:
        'Bitte beachten Sie: Abhängig von Ihrem Gerät könnte das Layout von Instagram etwas anders aussehen. Es ist zudem nicht möglich, Storys über die Computer-App zu posten. Weitere Informationen speziell zum Posten auf Instagram finden Sie <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">hier</a> in den offiziellen Richtlinien und Tipps.',
    },
    downloadable: {
      title: "Herunterladbare Inhalte",
      slides: [
        {
          image: require("@/assets/country-downloadable/AT-de/at-de-1.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/AT-de/at-de-2.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/AT-de/at-de-3.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/AT-de/at-de-1.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/AT-de/at-de-2.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/AT-de/at-de-3.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/AT-de/at-de-4.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/AT-de/at-de-5.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/AT-de/at-de-5.mp4"),
        },
      ],
    },
  },

  de_de: {
    navbar: {
      logo: "logo_lieferando.svg",
      link: "https://www.lieferando.de/",
      language: "Spraache",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "de",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "So bewerben Sie Ihre",
      h1Bold: "Marke auf Social Media",
      paragraph:
        "Ihr Geschäft auf Social Media zu bewerben ist eine kosteneffiziente Möglichkeit, potenzielle Kund:innen zu erreichen und sich von der Konkurrenz abzuheben. In diesem Artikel erhalten Sie Tipps und Tricks, wie Sie unser brandneues Social-Media-Paket nutzen können, um die Kundenbindung zu steigern. Alles wird Schritt für Schritt erklärt. Zeigen Sie allen, dass Sie über Lieferando bei Ihnen bestellen können!",
    },
    doDont: {
      title: "Social-Media-Marketing: Dos and Don’ts",
      items: [
        {
          type: "do",
          text: "Teilen Sie Posts morgens während der Rushhour und nach dem Feierabend. Zu diesen Zeiten sind die meisten Menschen online.",
        },
        {
          type: "do",
          text: "Nutzen Sie kurze, prägnante Texte, leuchtende Farben und Hashtags, um mit Ihren Inhalten mehr Leute zu erreichen.",
        },
        {
          type: "do",
          text: "Fordern Sie dazu auf, dass die Leute ihre Freund:innen markieren, Fragen stellen oder Kommentare posten.",
        },
        {
          type: "dont",
          text: "Kommunizieren Sie nicht mit Spam-Konten, die Sie vielleicht nur in einen Online-Streit verwickeln wollen.",
        },
        {
          type: "dont",
          text: "Nutzen Sie nicht zu viele Hashtags. Wählen Sie fünf bis zehn, die genau zu Ihrem Geschäft passen. Beispiele: #Pizzeria #Vegan #Nachhaltigkeit.",
        },
        {
          type: "dont",
          text: "Verwenden Sie keinen Benutzernamen, der sich von Ihrem Geschäftsnamen unterscheidet. Denn potenzielle Kund:innen sollen Sie leicht finden und erkennen können.",
        },
      ],
      taglineTitle:
        "Personalisieren Sie die Texte zu Ihrer Story, damit sie zu Ihrem Geschäft passen.",
      taglineItems: [
        {
          text: "Sie können Angebote oder neue Gerichte auf Ihrer Speisekarte bewerben.",
        },
        {
          text: "Ein paar Beispiele: „Freitag ist Burger-Tag: 2 zum Preis von 1“ oder „Neu: Vegane Pizza mit deinem Wunschbelag“ oder „Keine Lust auf Kochen? Nutze unser Mittagsangebot!“",
        },
      ],
    },
    insta: {
      title: "So posten Sie Storys auf Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Öffnen Sie Instagram und tippen Sie auf den „+“-Button unten mittig in der App. Nun können Sie ein neues Video drehen, ein Foto machen oder Ihre Galerie aufrufen und ein bereits vorhandenes Video bzw. Foto auswählen.",
        },
        {
          img: "Language.png",
          content:
            "Fügen Sie eine Beschreibung, Hashtags oder den Link zu Ihrer Webseite hinzu. Wenn Sie ein Video oder Foto ohne passende Beschreibung oder Informationen posten, reagieren Follower und Besucher wahrscheinlich weniger darauf.",
        },
        {
          img: "CircleStar.png",
          content:
            "Besonders dynamisch wirken Instagram-Storys mit Stickern von Giphy. Tippen Sie hierfür auf das Sticker-Symbol und suchen Sie dann per Stichwort nach dem passenden Sticker. Stichworte könnten etwa „Happy“ oder „Feier“ oder „lustige Katze“ sein. Dann werden Ihnen verschiedene Sticker zur Auswahl angezeigt. Mit Ihren Fingern können Sie nun den Sticker in der Größe anpassen oder rotieren.",
        },
        {
          img: "Policies.png",
          content:
            "Wenn Sie eine Kopie speichern möchten, tippen Sie auf die drei Punkte („Mehr“) unten rechts und wählen Sie „Foto/Video speichern“, um es auf Ihrem Gerät zu speichern.",
        },
      ],
      terms:
        'Bitte beachten Sie: Abhängig von Ihrem Gerät könnte das Layout von Instagram etwas anders aussehen. Es ist auch nicht möglich, Storys über die Computer-App zu posten. Weitere Informationen speziell zum Posten auf Instagram finden Sie <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">hier</a> in den offiziellen Richtlinien und Tipps.',
    },
    downloadable: {
      title: "Herunterladbare Inhalte",
      slides: [
        {
          image: require("@/assets/country-downloadable/DE/de-1.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/DE/de-2.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/DE/de-3.png"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/DE/de-de-1.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-de-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DE/de-de-2.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-de-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DE/de-de-3.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-de-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DE/de-de-4.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-de-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/DE/de-de-5.mp4"),
          buttonText: "Jetzt herunterladen",
          buttonURL: require("@/assets/country-downloadable/DE/de-de-5.mp4"),
        },
      ],
    },
  },

  pl_pl: {
    navbar: {
      logo: "logo_pl.svg",
      link: "https://www.justeat.it/",
      language: "Język",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "pl",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "Przewodnik po promowaniu marki",
      h1Bold: "w mediach społecznościowych",
      paragraph:
        "Marketing w mediach społecznościowych to jeden z najefektywniejszych sposobów dotarcia do klientów i wyróżnienia się wśród konkurencji. W tym artykule znajdziesz kilka wskazówek dotyczących korzystania z nowego pakietu do mediów społecznościowych i zwiększenia zaangażowania odbiorców. Niech wszyscy dowiedzą się, że realizujesz zamówienia przez Pyszne.pl!",
    },
    doDont: {
      title: "Dobre i złe praktyki w mediach społecznościowych",
      items: [
        {
          type: "do",
          text: "Udostępniaj posty w godzinach dojazdów do pracy i po południu, gdy większość użytkowników jest online.",
        },
        {
          type: "do",
          text: "Używaj krótkich, chwytliwych haseł, jasnych kolorów oraz hasztagów, aby zwiększyć zasięg swoich treści.",
        },
        {
          type: "do",
          text: "Zachęcaj ludzi do oznaczania znajomych, zadawania pytań i komentowania.",
        },
        {
          type: "dont",
          text: "Nie odpowiadaj na komentarze z podejrzanych kont, które mogą wciągać Cię w internetowe kłótnie.",
        },
        {
          type: "dont",
          text: "Nie nadużywaj hasztagów. Wybierz 5–10, które najlepiej opisują Twój biznes, np. #pizzeria #vegan #zrownowazonyrozwoj.",
        },
        {
          type: "dont",
          text: "Nie używaj nazwy użytkownika, która jest inna od nazwy Twojej firmy. Zadbaj o to, aby użytkownicy mogli do Ciebie łatwo dotrzeć.",
        },
      ],
      taglineTitle:
        "Spersonalizuj swój opis, aby jak najlepiej pasował do Twojego biznesu.",
      taglineItems: [
        {
          text: "Możesz napisać o swoich ofertach i okazjach lub nowych daniach dostępnych w menu.",
        },
        {
          text: "Dla przykładu: „Burgery 2 za 1 w każdy piątek”, „Nowa wegańska pizza – stwórz ją po swojemu” lub „Nie masz ochoty gotować? Sprawdź naszą ofertę”.",
        },
      ],
    },
    insta: {
      title: "Jak publikować relacje na Instagramie?",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Otwórz Instagram i znajdź przycisk „+” w centralnej części aplikacji. Naciśnij go, aby zrobić zdjęcie, nagrać wideo lub przejść do galerii w telefonie i skorzystać z plików, które już się w niej znajdują.",
        },
        {
          img: "Language.png",
          content:
            "Dodaj napisy, hasztagi lub link do firmowej strony internetowej. Brak tych elementów może sprawić, że relacja nie będzie angażująca.",
        },
        {
          img: "CircleStar.png",
          content:
            "Spraw, aby relacje były bardziej dynamiczne, dodając naklejki z Giphy. Możesz to zrobić poprzez dotknięcie ikony naklejki i wyszukanie słowa kluczowego, które najlepiej opisuje to, co chcesz wstawić, np. #happy #funnycat. Po chwili zobaczysz propozycje, z których możesz skorzystać. Wykonaj gest zsuwania/rozsuwania palców, aby zmienić rozmiar naklejki lub ją obrócić.",
        },
        {
          img: "Policies.png",
          content:
            "Jeśli chcesz zachować kopię, dotknij trzech kropek („Więcej”) w prawym dolnym rogu i wybierz „Zapisz zdjęcie/wideo”, aby zapisać je na swoim urządzeniu.",
        },
      ],
      terms:
        'Pamiętaj, że interfejs Instagrama może się różnić w zależności od urządzenia, z jakiego korzystasz. Nie ma możliwości publikowania relacji poprzez aplikację na komputerze. Więcej informacji o publikowaniu na Instagramie znajdziesz <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">tutaj</a>.',
    },
    downloadable: {
      title: "Materiały do pobrania",
      slides: [
        {
          image: require("@/assets/country-downloadable/PL/pl-1.png"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/PL/pl-2.png"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/PL/pl-3.png"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/PL/pl-pl-1.mp4"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-pl-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/PL/pl-pl-2.mp4"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-pl-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/PL/pl-pl-3.mp4"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-pl-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/PL/pl-pl-4.mp4"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-pl-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/PL/pl-pl-5.mp4"),
          buttonText: "Pobierz teraz",
          buttonURL: require("@/assets/country-downloadable/PL/pl-pl-5.mp4"),
        },
      ],
    },
  },

  it_it: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.justeat.it/",
      language: "Language",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "it",
          url: "https://couriers.just-eat.co.uk/application",
          text: "Great Britain",
        },
      ],
    },
    hero: {
      h1Plain: "Guida alla promozione del tuo",
      h1Bold: "brand sui social media",
      paragraph:
        "Promuovere la tua attività sui social media è uno dei modi più efficienti e convenienti per raggiungere potenziali clienti e distinguerti dalla concorrenza. Questo articolo contiene suggerimenti utli per usare il nostro nuovo Kit per social media per aumentare il coinvolgimento dei clienti, oltre a linee guida passo per passo. Fai sapere a tutti che possono ordinare da te su Just Eat!",
    },
    doDont: {
      title: "Cose da fare e da non fare nel social media marketing",
      items: [
        {
          type: "do",
          text: "Condividere post durante l’orario di lavoro e dopo il lavoro, quando la maggior parte delle persone sono online.",
        },
        {
          type: "do",
          text: "Usare testi brevi ed accattivanti, colori brillanti e hashtag per espandere ulteriormente la portata dei tuoi contenuti.",
        },
        {
          type: "do",
          text: "Incoraggiare le persone a taggare i loro amici, porre delle domande e commentare.",
        },
        {
          type: "dont",
          text: "Interagire con profili spam che cercano di indurti a partecipare a discussioni online.",
        },
        {
          type: "dont",
          text: "Usare eccessivamente hashtag. Selezionane da cinque a dieci che descrivano accuratamente la tua attività come #pizzeria #vegana #sostenibilità.",
        },
        {
          type: "dont",
          text: "Avere un nome utente diverso dal nome dell’attività, al contrario, è preferibile che i potenziali clienti siano in grado di trovarti facilmente e di interagire.",
        },
      ],
      taglineTitle:
        "Personalizza le didascalie delle tue storie in base alle caratteristiche specifiche della tua attività.",
      taglineItems: [
        {
          text: "Puoi presentare le offerte e le promozioni in corso, oppure i nuovi piatti che hai appena aggiunto al menù.",
        },
        {
          text: "Qualche esempio: “Ogni venerdì, 2 hamburger al prezzo di 1”, oppure “Nuove pizze speciali con farcitura a scelta”, o ancora “Non ti va di cucinare? Ecco le nostre offerte per la pausa pranzo!”",
        },
      ],
    },
    insta: {
      title: "Come postare storie su Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Apri Instagram, vai al tasto ‘+’ al centro della app in basso: da lì puoi filmare un nuovo video o scattare una foto, o accedere alla galleria del tuo telefono ed utilizzare un video o una foto già esistenti.",
        },
        {
          img: "Language.png",
          content:
            "Aggiungi una didascalia, un hashtag, o un link al sito web della tua attività. Pubblicare semplicemente un video o una foto senza poche parole di descrizione o informazioni aggiuntive può causare una mancanza di coinvolgimento.",
        },
        {
          img: "CircleStar.png",
          content:
            "Rendi più dinamiche le tue storie su Instagram aggiungendo gli sticker di Giphy. Puoi farlo toccando l’icona con lo sticker e poi cercando la parola chiave per lo sticker che cerchi, ad esempio “felice” o “festa” o “gattino”. Vedrai una serie di sticker diversi da cui scegliere. Muovi le dita avvicinandole/allontanandole per ridimensionare o ruotare l’adesivo.",
        },
        {
          img: "Policies.png",
          content:
            'Se desideri conservarne una copia, tocca i tre punti (“Altro”) in basso a destra e selezione “Salva Foto/Video" per salvarla sul tuo dispositivo.',
        },
      ],
      terms:
        'Ti preghiamo di notare che a seconda del tuo dispositivo, il layout di Instagram potrebbe apparire diverso. Inoltre non è possibile pubblicare storie sull’app per computer. Per ulteriori informazioni specifiche della pubblicazione di storie su Instagram, guarda le linee guida ufficiali e i consigli <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">qui</a>.',
    },
    downloadable: {
      title: "Kit scaricabili",
      slides: [
        {
          image: require("@/assets/country-downloadable/IT/it-1.png"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/IT/it-2.png"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/IT/it-3.png"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/IT/it-it-1.mp4"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-it-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/IT/it-it-2.mp4"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-it-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/IT/it-it-3.mp4"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-it-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/IT/it-it-4.mp4"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-it-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/IT/it-it-5.mp4"),
          buttonText: "Scarica ora",
          buttonURL: require("@/assets/country-downloadable/IT/it-it-5.mp4"),
        },
      ],
    },
  },

  es_es: {
    navbar: {
      logo: "logo_je.svg",
      link: "https://www.just-eat.es/",
      language: "Language",
      name: "Just Eat",
      country_toggle: [
        {
          logo: "es",
          url: "",
          text: "",
        },
      ],
    },
    hero: {
      h1Plain: "Guía para promover tu marca",
      h1Bold: "en las redes sociales",
      paragraph:
        "¡Aprovecha el marketing en redes sociales para destacar tu marca!<br><br>En este artículo, descubrirás consejos prácticos y trucos para utilizar nuestro nuevo kit para redes sociales.<br><br>Además, te proporcionamos guías paso a paso para fomentar la participación de tus clientes.<br><br>¡Hazte más visible y aumenta tus pedidos!",
    },
    doDont: {
      title: "Marketing en las redes: ¿qué debes hacer y qué debes evitar?",
      items: [
        {
          type: "do",
          text: "Comparte publicaciones en las horas en las que la gente va o vuelve del trabajo, pues son los horarios con más gente conectada.",
        },
        {
          type: "do",
          text: "Usa textos cortos y llamativos, colores atractivos y etiquetas (hashtags) para ampliar el alcance de tu contenido.",
        },
        {
          type: "do",
          text: "Anima a la gente a que etiquete a sus amigos, haga preguntas y comente en tus publicaciones.",
        },
        {
          type: "dont",
          text: "Interactuar con cuentas spam que intenten convencerte para participar en discusiones online.",
        },
        {
          type: "dont",
          text: "Usar demasiados hashtags. Selecciona entre cinco y diez que describan bien tu negocio, como #pizzería #vegano #sostenible.",
        },
        {
          type: "dont",
          text: "Usar un nombre de usuario que no coincida con el nombre de tu empresa; la idea es que los posibles clientes te encuentren e interactúen fácilmente.",
        },
      ],
      taglineTitle: "Cómo personalizar tu publicación y hacerla más atractiva:",
      taglineItems: [
        {
          text: "Menciona tus ofertas, descuentos, o nuevos artículos / platos",
        },
        {
          text: "Por ejemplo, “2x1 en hamburguesas los viernes”, “Nuevas pizzas veganas” o, incluso algo como “¿No te apetece cocinar? Echa un vistazo a los platos en promoción”.",
        },
      ],
    },
    insta: {
      title: "Cómo publicar historias en Instagram",
      slides: [
        {
          img: "Hackathon.png",
          content:
            "Abre Instagram, pulsa el botón “+” que está abajo, en el centro; desde ahí puedes grabar un nuevo vídeo o hacer una foto, o acceder a la galería de fotos de tu teléfono y usar una foto o vídeo que ya tengas.",
        },
        {
          img: "Language.png",
          content:
            "Añade un texto, hashtag o enlace a la web de tu negocio. Publicar un vídeo o foto sin añadir una breve descripción o información adicional puede hacer que poca gente participe en la publicación.",
        },
        {
          img: "CircleStar.png",
          content:
            "Haz que tus historias en Instagram sean más dinámicas añadiendo pegatinas. Para ello, selecciona el icono de las pegatinas y busca palabras clave para encontrar la que quieres, como “felicidad” o “celebración”. Verás que puedes elegir entre una variedad de pegatinas. Con dos dedos hacia fuera o hacia dentro puedes hacerla más grande o pequeña, o puedes girarla.",
        },
        {
          img: "Policies.png",
          content:
            "Si deseas tener una copia de tu contenido, pulsa en los tres puntos (“Más”) que está en la esquina inferior derecha y selecciona “Guardar foto/vídeo”. De esta manera se almacenara en tu dispositivo.",
        },
      ],
      terms:
        'Ten en cuenta que, dependiendo de tu dispositivo, las opciones de Instagram pueden ser diferente. Tampoco es posible publicar historias desde el ordenador. Puedes obtener más información sobre las publicaciones en Instagram <a href="https://help.instagram.com/1660923094227526/?helpref=hc_fnav&cms_id=1660923094227526" target="_blank">aquí</a>.',
    },
    downloadable: {
      title: "Descarga tu Kit para redes sociales",
      slides: [
        {
          image: require("@/assets/country-downloadable/ES/es-1.png"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-1.png"),
        },
        {
          image: require("@/assets/country-downloadable/ES/es-2.png"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-2.png"),
        },
        {
          image: require("@/assets/country-downloadable/ES/es-3.png"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-3.png"),
        },
      ],
      stickers: [
        {
          sticker: require("@/assets/country-downloadable/ES/es-es-1.mp4"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-es-1.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/ES/es-es-2.mp4"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-es-2.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/ES/es-es-3.mp4"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-es-3.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/ES/es-es-4.mp4"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-es-4.mp4"),
        },
        {
          sticker: require("@/assets/country-downloadable/ES/es-es-5.mp4"),
          buttonText: "Descargar ahora",
          buttonURL: require("@/assets/country-downloadable/ES/es-es-5.mp4"),
        },
      ],
    },
  },
};
